import ReactMarkdown, { type Components } from "react-markdown";
import remarkGfm from "remark-gfm";
import { cn } from "@volca/ui/lib/utils";

const markdownComponents: Components = {
  h1: ({ children }) => <h2>{children}</h2>,
  h2: ({ children }) => <h3>{children}</h3>,
  h3: ({ children }) => <h4>{children}</h4>,
  h4: ({ children }) => <h5>{children}</h5>,
  h5: ({ children }) => <h6>{children}</h6>,
  table: ({ children }) => (
    <div className="typeset-scroll overflow-x-auto">
      <table>{children}</table>
    </div>
  ),
};

interface PayPlanMarkdownProps {
  document: string;
  className?: string;
}

export const PayPlanMarkdown = ({
  document,
  className,
}: PayPlanMarkdownProps) => (
  <div className={cn("typeset min-w-0", className)}>
    <ReactMarkdown components={markdownComponents} remarkPlugins={[remarkGfm]}>
      {document}
    </ReactMarkdown>
  </div>
);
